import { useQuery } from "@tanstack/react-query";
import { Flex, Result, Spin, Typography, Image, Divider } from "antd";
import { useParams } from "react-router-dom";
import { getBlogById } from "Features/Blog/apis/blogs";
import "./styles/singleBlog.css";

const { Title, Paragraph } = Typography;

export default function SingleBlog() {
  const { blogId } = useParams();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["blog", blogId],
    queryFn: () => getBlogById(blogId),
    enabled: Boolean(blogId),
  });

  const blog = data?.blog;

  if (isLoading)
    return (
      <Flex justify="center" align="center" style={{ height: "100vh" }}>
        <Spin size="large" />
      </Flex>
    );

  if (isError)
    return (
      <Result status="500" title="Error" subTitle="Please try again later" />
    );

  return (
    blog && (
      <div className="single-blog-container">
        <Title level={1} className="single-blog-title">
          {blog.heading}
        </Title>
        {blog?.imageUrl && (
          <Image
            src={blog.imageUrl}
            alt="Blog Hero"
            preview={false}
            className="single-blog-hero-image"
          />
        )}
        <div className="single-blog-content">
          <Paragraph className="single-blog-intro">{blog.intro}</Paragraph>
          <Divider />
          {blog.sections.map((section, index) => (
            <div key={index} className="single-blog-section">
              <Title level={3} className="single-blog-section-title">
                {section.title}
              </Title>
              <Paragraph className="single-blog-section-content">
                {section.content}
              </Paragraph>
            </div>
          ))}
        </div>
      </div>
    )
  );
};
